import { mstCommon } from '@libs/domain';
import { Characters, Item, ItemName, Locale } from '@ps-smart-cp/ppfw-client';
import { useMstSettings } from '../../../context';

export function useLocationItems() {
  const { location } = useMstSettings();

  if (!location.isUsed) return null;

  const name = ItemName.of([Locale.ja, location.displayName]);
  const attr = Characters.preset.halfWidth({
    minLen: +location.codeDigits,
    maxLen: +location.codeDigits,
    required: true,
  });

  return {
    code: Item.of(mstCommon.names.code, attr),
    locationMstCode: Item.of(name, attr.replaceRequired(false)),
    locationCode: Item.of(name, attr.replaceRequired(false)),
    name,
  };
}
